import { ColumnDefinition } from '@scope/scope-one-ui/core/DataTable/DataTable.d';
import { SIZES } from '@scope/scope-one-ui/theme';
import { rangeRenderer, scoreRenderer, sentimentRenderer } from '../../utils/renderers';

export const cols: ColumnDefinition[] = [
  {
    name: 'name',
    label: 'Event name / Sentiment',
    customBodyRender: sentimentRenderer,
  },
  {
    name: 'sentimentScore',
    align: 'center',
    label: 'SENTIMENT SCORE (pts)',
    columns: [
      {
        name: 'scoreOne',
        label: ['1M', '3M', '6M', '1Y', '7D'],
        align: 'center',
        size: SIZES.spacing(15),
        customBodyRender: scoreRenderer('numeric'),
      },
      {
        name: 'scoreTwo',
        label: ['3M', '6M', '1Y', '7D', '1M'],
        align: 'center',
        size: SIZES.spacing(15),
        customBodyRender: scoreRenderer('numeric'),
      },
      {
        name: 'rangeScore',
        label: 'Today vs 1Y Range',
        customBodyRender: rangeRenderer,
      },
    ],
  },
  {
    name: 'attentionBuzz',
    align: 'center',
    label: 'ATTENTION BUZZ (%)',
    columns: [
      {
        name: 'buzzOne',
        label: ['1M', '3M', '6M', '1Y', '7D'],
        align: 'center',
        size: SIZES.spacing(15),
        customBodyRender: scoreRenderer('percentage'),
      },
      {
        name: 'buzzTwo',
        label: ['3M', '6M', '1Y', '7D', '1M'],
        align: 'center',
        size: SIZES.spacing(15),
        customBodyRender: scoreRenderer('percentage'),
      },
    ],
  },
  {
    name: 'mentions',
    label: '# of Mentions',
    size: 'min-content',
  },
  {
    name: 'types',
    label: 'Influencer types / Sentiment',
    customBodyRender: sentimentRenderer,
  },
];
